/* global axios */
import ApiClient from './ApiClient';

class CatalogProductsAPI extends ApiClient {
  constructor() {
    super('catalog/products', { accountScoped: true, apiVersion: 'v2' });
  }

  // O controller espera os campos sob a chave `product` (params.require(:product)).
  create(data) {
    return axios.post(this.url, { product: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { product: data });
  }

  search(query) {
    return axios.get(this.url, { params: { query } });
  }

  importCsv(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Reusa a URL account-scoped trocando o recurso pelo endpoint da Braavo.
  braavoUrl(suffix) {
    return this.url.replace(
      /\/catalog\/products$/,
      `/integrations/braavo/${suffix}`
    );
  }

  syncBraavo({ categoryIds, maxProducts } = {}) {
    return axios.post(this.braavoUrl('sync'), {
      category_ids: categoryIds,
      max_products: maxProducts,
    });
  }

  braavoCategories() {
    return axios.get(this.braavoUrl('categories'));
  }

  braavoSyncStatus() {
    return axios.get(this.braavoUrl('sync_status'));
  }
}

export default new CatalogProductsAPI();
